import { createRoot } from 'react-dom/client';
import { RelayEnvironmentProvider } from 'react-relay';
import serverVars from 'server-vars';

import { IntlProvider } from 'dibs-react-intl';
import { clientIntlPolyfill } from 'dibs-buyer-layout/exports/clientIntlPolyfill';
import { initVisitorTracking } from 'dibs-buyer-layout/src/entries/index';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';

import IFramedPromoPartnershipWrapper from '../iFramedPromoPartnership/IFramedPromoPartnershipWrapper';

const locale = serverVars.get('locale');
const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

async function renderIframedPromoPartnership(): Promise<void> {
    await clientIntlPolyfill();

    const rootElement = document.getElementById('js-root');
    if (rootElement) {
        const root = createRoot(document.getElementById('promo-partnership-root') as HTMLElement);
        root.render(
            <IntlProvider locale={locale} disableTranslations>
                <RelayEnvironmentProvider environment={environment}>
                    <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
                        <IFramedPromoPartnershipWrapper />
                    </ErrorBoundary>
                </RelayEnvironmentProvider>
            </IntlProvider>
        );

        // normally done in dbl, but this page doesn't use it
        initVisitorTracking();
    }
}

renderIframedPromoPartnership();
